var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.googleTagId)?[_c('noscript',[_c('iframe',{staticStyle:{"display":"none","visibility":"hidden"},attrs:{"src":_vm.source,"height":"0","width":"0"}})])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }